<div
  dcpAutofocus
  tabindex="0"
  role="document"
  class="modal-dialog h-100 my-0 me-0"
>
  <div
    class="modal-content udex-px-24"
    (click)="$event.stopPropagation()"
  >
    <ng-container *ngIf="searchResult$ | async as searchResult">
      <ng-container *ngIf="facetList$ | async as facetList">
        <div class="d-flex justify-content-between udex-py-16">
          <div>
            <udex-button
              size="Medium"
              design="Primary"
              class="udex-me-8"
              (click)="launchDialogService.closeDialog('Modal close button clicked')"
            > {{'search.showResults' | cxTranslate}} </udex-button>
            <udex-button
              size="Medium"
              design="Tertiary"
              (click)="clearAll();launchDialogService.closeDialog('Modal close button clicked')"
            > {{'search.reset' | cxTranslate}} </udex-button>
          </div>
          <udex-button
            size="Medium"
            icon="decline"
            design="Tertiary"
            icon-only
            (click)="launchDialogService.closeDialog('Modal close button clicked')"
          ></udex-button>
        </div>
        <udex-accordion-item
          [title]="'search.mobileSortBy' | cxTranslate"
          (click)="showSortingOptions(searchResult.sorts)"
          class="heading__bold--l"
        >
          <ng-container *ngFor="let option of selectedSortOptions">
            <udex-radio-button
              class="d-flex"
              value-state="None"
              name="sort-group"
              [text]="option.name"
              [checked]="option.selected"
              (click)="sortList(option.code);launchDialogService.closeDialog('Modal close button clicked')"
            ></udex-radio-button>
          </ng-container>
        </udex-accordion-item>
        <ng-container *ngFor="let facet of facetList; let i=index">
          <udex-accordion-item
            [title]="facet.name"
            class="heading__bold--l"
          >
            <udex-list mode="MultiSelect">
              <dcp-mobile-facet-value
                [facet]="facet"
                [filteredFacetValues]="facet.values"
              ></dcp-mobile-facet-value>
            </udex-list>
          </udex-accordion-item>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>
